<div mat-dialog-content>
    <kiene-untersuchungsmaterial-konfigurator
        (changedUntersuchungsmaterial)="untersuchungsmaterialChanged($event)"
        [untersuchungsmaterial]="material"
    ></kiene-untersuchungsmaterial-konfigurator>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
</div>
